import utils from '../../utils'
import ZjApp from './App.vue'

const cmps = {
    ZjApp
}

const install = function(Vue) {
    utils.each(cmps, cmp=>Vue.component(cmp.name, cmp))
}

export default {
    install,
    ...cmps
}